// future proofing validation stuff
const validateFile = (file, config) => {
  const { allowedFileFormats, fileSizeMBLimit } = config;
  const { size, type } = file;

  let isValidFile = false;
  let err = false;

  if (!allowedFileFormats.includes(type)) {
    err = `${type} file format is not allowed`;
  } else if (size / 1024 / 1024 > fileSizeMBLimit) {
    err = `File size exceeded the limit of ${fileSizeMBLimit}MB`;
  } else {
    isValidFile = true;
  }

  return {
    isValidFile,
    errVal: err,
  };
};

export const fileValidator = (files, config) => {
  const { filesLimit } = config;
  const { length } = files;
  const err = false;
  const result = {
    isValidFile: false,
    errVal: err,
  };

  if (length === 0) {
    return result;
  }
  if (length > filesLimit) {
    result.errVal = filesLimit > 1
      ? `Only ${filesLimit} files are allowed to be uploaded at a time`
      : 'Only one file is allowed to be uploaded at a time';
    return result;
  }

  const results = [];
  for (let i = 0; i < files.length; i += 1) {
    results.push(validateFile(files[i], config));
  }
  return results;
};

export const preventBrowserDefaults = (e) => {
  e.preventDefault();
  e.stopPropagation();
};
